import { render } from "./Footer.vue?vue&type=template&id=c5649940&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=c5649940&lang=scss&scoped=true"

import exportComponent from "F:\\work\\frontend\\vue\\jp_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5649940"]])

export default __exports__